export default "__VITE_ASSET__48ea89a3__"